import React, { useEffect, useState } from 'react';
import '../styles/WelcomeCard.css';
import botLogo from '../../../assets/SigerBotLogo.png';

const WelcomeCard = () => {
  const [isAnimationComplete, setIsAnimationComplete] = useState(false);

  useEffect(() => {
    // Animación del avatar: 3 saltitos de ~600ms total
    // Luego mostrar el mensaje
    const timer = setTimeout(() => {
      setIsAnimationComplete(true);
    }, 1000);

    return () => clearTimeout(timer);
  }, []);

  return (
    <div className="welcome-card-container">
      <div className="welcome-card">
        <div className="welcome-avatar-wrapper">
          <img
            src={botLogo}
            alt="SigerBot"
            className="welcome-avatar"
            loading="eager"
          />
        </div>

        {isAnimationComplete && (
          <div className="welcome-message-wrapper">
            <p className="welcome-message">
              Hola, soy SigerBot. Puedo ayudarte a analizar consumos, costos, matriz energética, alertas y reportes dentro de SIGER. ¿Qué querés revisar hoy?
            </p>
          </div>
        )}
      </div>
    </div>
  );
};

export default WelcomeCard;
